import * as React from "react";
import styled from "styled-components";

import { CategorizedCompanyValueFeature } from "../entities";
import CompanyValuesPicker from "./CompanyValuesPicker";
import CompanyValuesSorter from "./CompanyValuesSorter";
import CompanyValuesSelectorActions from "./CompanyValuesSelectorActions";
import FeedbackLink from "./FeedbackLink";
import WithLocale from "../../common/components/WithLocale";

interface Props {
  features: CategorizedCompanyValueFeature[];
  selectedFeatures: string[];
  onChange(features: string[]): void;
  onSubmit(): void;
  onCancel(): void;
}

const VALID_REQUEST_FORM_LOCALES = ["ja"];

class CompanyValuesSelector extends React.PureComponent<Props> {
  public render() {
    const { features, selectedFeatures, onChange, onSubmit, onCancel } = this.props;
    return (
      <WithLocale>
        {({ translate: t, locale }) => (
          <Wrapper>
            <CompanyValuesPicker features={features} selectedFeatures={selectedFeatures} onChange={onChange} />
            <RightCol>
              <Heading>{t("company.values.message")}</Heading>
              <Para>{t("company.values.sub_message")}</Para>
              <SorterWrapper>
                <CompanyValuesSorter
                  selectedFeatures={selectedFeatures}
                  onChange={features => {
                    this.props.onChange(features);
                  }}
                />
              </SorterWrapper>
              <CompanyValuesSelectorActions
                onSubmit={onSubmit}
                onCancel={onCancel}
                selectedCount={selectedFeatures.length}
              />
              {VALID_REQUEST_FORM_LOCALES.includes(locale) && (
                <FeedbackLinkWrapper>
                  <FeedbackLink />
                </FeedbackLinkWrapper>
              )}
            </RightCol>
          </Wrapper>
        )}
      </WithLocale>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;

const RightCol = styled.div`
  width: 325px;
  box-sizing: border-box;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const SorterWrapper = styled.div`
  padding: 12px;
`;

const Heading = styled.div`
  margin: 40px 30px 0;
  font-weight: 600;
  font-size: 21px;
  line-height: 1.43;
  color: rgba(36, 40, 42, 1);
`;

const Para = styled.div`
  margin: 5px 30px 10px;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.67;
  color: rgba(0, 0, 0, 0.27);
`;

const FeedbackLinkWrapper = styled.div`
  padding: 0 20px 20px;
  font-size: 11px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.4);
`;

export default CompanyValuesSelector;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesSelector.tsx